import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HistoryService } from './history.service';
import { CloseHistoryStats, GetHistoryStats, OpenHistoryStats } from './history.actions';
import { patch } from '@ngxs/store/operators';
import { HistoryItem } from './models/history-item.model';
import { tap } from 'rxjs';
import { LoadingModel } from '../../../_core/state/loading.model';
import { finalize } from 'rxjs/operators';

export type HistoryStateModel = LoadingModel & {
  isStatsModalOpen: boolean;
  historyItem?: HistoryItem;
}

export const initialState: HistoryStateModel = {
  isLoading: false,
  isStatsModalOpen: false,
  historyItem: undefined,
}

@State<HistoryStateModel>({
  name: 'history',
  defaults: initialState,
})
@Injectable()
export class HistoryState {
  private readonly historyService = inject(HistoryService);

  @Selector()
  static isStatsModalOpen(state: HistoryStateModel): boolean {
    return state.isStatsModalOpen;
  }

  @Selector()
  static historyItem(state: HistoryStateModel): HistoryItem | undefined {
    return state.historyItem;
  }

  @Selector()
  static isLoading(state: HistoryStateModel) {
    return state.isLoading;
  }

  @Action(GetHistoryStats)
  getHistoryStats(context: StateContext<HistoryStateModel>, { recordId, type, parentId }: GetHistoryStats) {
    context.setState(patch({ isLoading: true }));

    return this.historyService.getHistoryItemStats(recordId, type, parentId).pipe(
      tap((item) => {
        context.setState(patch({ historyItem: item }));
      }),
      finalize(() =>
        context.setState(patch({ isLoading: false }))
      ),
    )
  }

  @Action(OpenHistoryStats)
  openHistoryStats(context: StateContext<HistoryStateModel>, { recordId, type, parentId }: OpenHistoryStats) {
    context.setState(patch({ isStatsModalOpen: true }));

    context.dispatch(new GetHistoryStats(recordId, type, parentId));
  }

  @Action(CloseHistoryStats)
  closeHistoryStats(context: StateContext<HistoryStateModel>) {
    context.setState(patch({ isStatsModalOpen: false, historyItem: undefined }));
  }
}

